import CompanyActivationContainer from 'modules/companyActivation/containers/CompanyActivationContainer';

const CompanyActivationView = props => <CompanyActivationContainer {...props} />;

export default CompanyActivationView;
